import PropTypes from 'prop-types';

export default {
  id: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
  documentPublishOption: PropTypes.string.isRequired,
}
